import { memo } from 'react'
import './ProfilePictureBackground.scss'

interface ProfilePictureBackgroundProps {
  className?: string
}

/**
 * Squircle (organic rounded-square) SVG used as the frame behind the
 * profile avatar. Stretches to its parent container via `width: 100%`
 * in SCSS, so callers control the rendered size via the wrapper. Fill
 * and stroke are theme-driven (`--card`, `--border`) — see
 * `ProfilePictureBackground.scss`.
 *
 * Based on Figma node-id 460:2675.
 */
const ProfilePictureBackgroundImpl = ({ className = '' }: ProfilePictureBackgroundProps) => (
  <svg
    width="83"
    height="83"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`profile-picture-background ${className}`.trim()}
  >
    <path
      d="M51.82 0.74C51.83 0.74 51.83 0.74 51.84 0.74C51.85 0.74 51.86 0.74 51.88 0.74C51.92 0.74 51.98 0.74 52.05 0.74C52.21 0.74 52.43 0.75 52.71 0.75C53.28 0.76 54.1 0.79 55.09 0.83C57.08 0.92 59.77 1.1 62.6 1.46C65.42 1.81 68.41 2.35 70.98 3.17C73.35 3.93 75.48 4.96 76.74 6.42L76.98 6.71C81.23 12.4 82.22 19.39 82.22 41.48C82.22 62.88 81.29 70.12 77.37 75.71L76.98 76.25C75.77 77.86 73.5 78.99 70.98 79.79C68.41 80.61 65.42 81.15 62.6 81.51C59.77 81.86 57.08 82.04 55.09 82.13C54.1 82.18 53.28 82.2 52.71 82.21C52.43 82.22 52.21 82.22 52.05 82.22C51.98 82.22 51.92 82.22 51.88 82.22C51.86 82.22 51.85 82.22 51.84 82.22C51.83 82.22 51.83 82.22 51.82 82.22H31.14C31.14 82.22 31.13 82.22 31.13 82.22C31.12 82.22 31.1 82.22 31.08 82.22C31.04 82.22 30.99 82.22 30.91 82.22C30.76 82.22 30.53 82.22 30.25 82.21C29.68 82.2 28.86 82.18 27.87 82.13C25.89 82.04 23.19 81.86 20.36 81.51C17.54 81.15 14.55 80.61 11.99 79.79C9.46 78.99 7.2 77.86 5.99 76.25C1.73 70.57 0.74 63.57 0.74 41.48C0.74 19.39 1.73 12.4 5.99 6.71L6.23 6.42C7.48 4.96 9.62 3.93 11.99 3.17C14.55 2.35 17.54 1.81 20.36 1.46C23.19 1.1 25.89 0.92 27.87 0.83C28.86 0.79 29.68 0.76 30.25 0.75C30.53 0.75 30.76 0.74 30.91 0.74C30.99 0.74 31.04 0.74 31.08 0.74C31.1 0.74 31.12 0.74 31.13 0.74C31.13 0.74 31.14 0.74 31.14 0.74H51.82Z"
      className="profile-picture-background__shape"
      strokeWidth="1.48148"
    />
  </svg>
)

// Stateless SVG with a single string prop — memoize so it doesn't
// re-render on every keystroke of a parent's name input or on
// AvatarPicker hover-state churn (100+ instances in the picker grid).
export const ProfilePictureBackground = memo(ProfilePictureBackgroundImpl)
